import {
    CREATE_GENERAL_PO_MASTER_REQUEST_DK,
    CREATE_GENERAL_PO_MASTER_SUCCESS_DK,
    CREATE_GENERAL_PO_MASTER_FAILURE_DK,
    DELETE_GENERAL_PO_MASTER_REQUEST_DK,
    DELETE_GENERAL_PO_MASTER_SUCCESS_DK,
    DELETE_GENERAL_PO_MASTER_FAILURE_DK,
    FETCH_SINGLE_GENERAL_PO_MASTER_REQUEST_DK,
    FETCH_SINGLE_GENERAL_PO_MASTER_SUCCESS_DK,
    FETCH_SINGLE_GENERAL_PO_MASTER_FAILURE_DK,
    FETCH_GENERAL_PO_MASTER_REQUEST_DK,
    FETCH_GENERAL_PO_MASTER_SUCCESS_DK,
    FETCH_GENERAL_PO_MASTER_FAILURE_DK,
    UPDATE_GENERAL_PO_MASTER_REQUEST_DK,
    UPDATE_GENERAL_PO_MASTER_SUCCESS_DK,
    UPDATE_GENERAL_PO_MASTER_FAILURE_DK,
    RESET_GENERAL_PO_MASTER_INFO_DK,
    CREATE_GENERAL_PO_MASTER_FORM_DK,
    UPDATE_GENERAL_PO_MASTER_FORM_DK,
    NAVIGATE_GENERAL_PO_DETAILS_DK,
    NAVIGATE_GENERAL_PO_MASTER_DK,
    FETCH_PROPERTY_DATA_FOR_GENERAL_PO_MASTER_SUCCESS_DK,
    FETCH_PROPERTY_DATA_FOR_GENERAL_PO_MASTER_FAILURE_DK,
    FETCH_PROPERTY_DATA_FOR_GENERAL_PO_MASTER_REQUEST_DK,
    GENERAL_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    GENERAL_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_GENERAL_PO_INVOICE_REQUEST,
    FETCH_GENERAL_PO_INVOICE_SUCCESS,
    FETCH_GENERAL_PO_INVOICE_FAILURE,
    RESET_GENERAL_PO_INVOICE,
    FETCH_GENERAL_PO_STYLE_REQUEST_DK,
    FETCH_GENERAL_PO_STYLE_SUCCESS_DK,
    FETCH_GENERAL_PO_STYLE_FAILURE_DK,
} from './generalPoMaster.actionsType';

export const GENERAL_PO_MASTER_DK = 'generalPoMasterDK';

let initialState = {
    loading: false,
    generalPoMaster: [],
    generalPoInvoice: [],
    generalPoStyleList:[],
    generalPoMasterForm: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    generalItemList: [],
    generalHeaderList: [],
    uomList: [],
    errorMessage: '',
    singleGeneralPoData: {},
    isGeneralPoDetails: false,
    detailsId: '',
    activeKey: 1
};

export let generalPoMasterDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_GENERAL_PO_MASTER_REQUEST_DK:
        case FETCH_GENERAL_PO_STYLE_REQUEST_DK:
        case FETCH_GENERAL_PO_INVOICE_REQUEST:
        case CREATE_GENERAL_PO_MASTER_REQUEST_DK:
        case UPDATE_GENERAL_PO_MASTER_REQUEST_DK:
        case FETCH_SINGLE_GENERAL_PO_MASTER_REQUEST_DK:
        case DELETE_GENERAL_PO_MASTER_REQUEST_DK:
        case FETCH_PROPERTY_DATA_FOR_GENERAL_PO_MASTER_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoMaster: updatePayload
            };
            case FETCH_GENERAL_PO_INVOICE_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    generalPoInvoice: updatePayload
                };
        case FETCH_PROPERTY_DATA_FOR_GENERAL_PO_MASTER_SUCCESS_DK:
            if (payload == 52) {
                return {
                    ...state,
                    loading: false,
                    typeOfPoList: updatePayload
                };
            } else if (payload == 46) {
                return {
                    ...state,
                    loading: false,
                    sourceList: updatePayload
                };
            } else if (payload == 28) {
                return {
                    ...state,
                    loading: false,
                    departmentList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    deliveryAt: updatePayload
                };
            } else if (payload == 22) {
                return {
                    ...state,
                    loading: false,
                    uomList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    generalHeaderList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    generalItemList: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_GENERAL_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case UPDATE_GENERAL_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
            case FETCH_GENERAL_PO_STYLE_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    generalPoStyleList: updatePayload
                };
        case FETCH_SINGLE_GENERAL_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoMasterForm: updatePayload
            };
        case DELETE_GENERAL_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case RESET_GENERAL_PO_MASTER_INFO_DK:
            return {
                ...state,
                generalPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                activeKey: 1
            };
        case CREATE_GENERAL_PO_MASTER_FORM_DK:
        case UPDATE_GENERAL_PO_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                generalPoMasterForm: {
                    ...state.generalPoMasterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_GENERAL_PO_MASTER_FAILURE_DK:
        case FETCH_GENERAL_PO_INVOICE_FAILURE:
        case FETCH_GENERAL_PO_STYLE_FAILURE_DK:
        case CREATE_GENERAL_PO_MASTER_FAILURE_DK:
        case UPDATE_GENERAL_PO_MASTER_FAILURE_DK:
        case FETCH_SINGLE_GENERAL_PO_MASTER_FAILURE_DK:
        case DELETE_GENERAL_PO_MASTER_FAILURE_DK:
        case FETCH_PROPERTY_DATA_FOR_GENERAL_PO_MASTER_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_GENERAL_PO_DETAILS_DK:
            return {
                ...state,
                isGeneralPoDetails: true,
                singleGeneralPoData: updatePayload.singleGeneralPoData
            };
        case NAVIGATE_GENERAL_PO_MASTER_DK:
            return {
                ...state,
                isGeneralPoDetails: false
            };
            case RESET_GENERAL_PO_INVOICE:
                return {
                    ...state,
                    generalPoInvoice: []
                };
        case GENERAL_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                generalPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case GENERAL_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                generalPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
